'use client';

import { signOut } from 'next-auth/react';
import { useEffect } from 'react';

interface AuthErrorBoundaryProps {
  error: Error;
}

export default function AuthErrorBoundary({ error }: AuthErrorBoundaryProps) {
  useEffect(() => {
    if (error.name === 'AuthError') {
      signOut({ redirect: true, callbackUrl: '/login' });
    }
  }, [error]);

  return null;
}
